/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react'
import Upload from './Upload'
import CloseIcon from '@mui/icons-material/Close';
import { Grid, DialogTitle, DialogContent, Tooltip, IconButton, CircularProgress, Dialog, useTheme } from '@mui/material';
// import uploadIcon from '../../../public/images/uploadIcon.svg';
// import uploadIconActive from '../../../public/images/upload_icon_active.svg';
import config from '../../config';
import axios from '../../Helper/Axios/interceptor';

function ProofDialog({ onFile, ...props }) {
    const [docList, setDocList] = useState([])
    const [loader, setLoader] = useState(false)
    const [active, setActive] = useState(0)
    const [error, setError] = useState("")
    const [documentAcceptType, setDocumentAcceptType] = useState([])
    const theme = useTheme()

    const classes = {
        uploadWrapper: {
            border: "2px dashed #C5C4C4",
            padding: "8px 8px 0px 8px",
            borderRadius: "5px"
        },
        center: {
            textAlign: "center"
        },
        titleDiv: {
            marginTop: theme.spacing(2.5),
            marginBottom: theme.spacing(2)
        },
        title: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontWeight: 600
        },
        content: {
            marginBottom: theme.spacing(7)
        },
        active: {
            backgroundColor: '#24b7cc',
            padding: "8px 8px 0px 8px",
            height: "100%",
            borderRadius: "5px"
        },
        closeButton: {
            color: '#F54040',
            background: '#F4F4F4'
        },
    }

    useEffect(() => {
        if (props.data !== null) {
            setDocList([])
            setLoader(true)
            var requestobj;
            requestobj = {
                "docTypeCode": props.data
            }
            axios.get(`${process.env.REACT_APP_API_URL}${props.getDocumentTypeURL}`, requestobj)
                .then(response => {
                    if (response.data.success) {
                        setLoader(false)
                        setDocList(response.data.success)
                        if (response.data.success.length > 0) {
                            var docTypesArray = []
                            response.data.success.forEach((docType, index) => {
                                if (docType.documentFormat) {
                                    var splits = docType.documentFormat.split(",")
                                    var docTypeString = ""
                                    splits.forEach((split, i)=>{
                                        docTypeString = docTypeString + ("." + (split.trim()))
                                        if( i < (splits.length-1) ){
                                            docTypeString = docTypeString + ", "
                                        }
                                    })
                                    docTypesArray[index] = docType.documentFormat /* docTypeString */
                                }
                            })
                            setDocumentAcceptType([...docTypesArray])
                        }
                        setDocList(response.data.success.documentsReq)
                    }
                    else {
                        setError(response.data.error)
                    }
                })
                .catch(exception => {
                    // error
                    setError(exception.message)
                })
        } else {
            setLoader(true)
        }
    }, [props.data])

    useEffect(() => {
        setLoader(true)
    }, [])


    return <Dialog {...props} fullWidth={true} maxWidth='sm'>
        <DialogTitle className={classes.titleDiv}>
            <Grid container>
                <Grid item md={4} sm={4} xs={4}>
                </Grid>
                <Grid item md={4} sm={4} xs={4} className={classes.title} style={{ textAlign: "center" }}>
                    {props.dialogTitle}
                </Grid>
                <Grid item md={4} sm={4} xs={4}>
                    <Grid container>
                        <Grid item md={5} sm={5} xs={5}>
                        </Grid>
                        <Grid item md={4} sm={4} xs={4}>
                        </Grid>
                        <Grid item md={3} sm={3} xs={3}>
                            <Tooltip title="Close" aria-label="close">
                                <IconButton aria-label="close" className={classes.closeButton} onClick={props.handleClose} size="large">
                                    <CloseIcon />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </DialogTitle>
        <DialogContent className={classes.content}>
            <Grid container spacing={2} style={loader ? { display: 'flex', margin: 'auto', justifyContent: 'center', height: '80px' } : {}}>
                {
                    loader ?
                        <CircularProgress size={50} style={{ color: '#00000042' }} />
                        : <>{error ? <div style={{ textAlign: "center", width: "100%" }}>{error}</div> : docList.map((dt, i) => {
                            return <Grid item xs={6} md={4} className={classes.center} onClick={() => setActive(i)}>
                                {
                                    <Grid container spacing={2}>
                                        <Grid item md={2}>
                                        </Grid>
                                        <Grid item md={8} xs={12} sm={12} style={{ cursor: "pointer" }}>
                                            <Upload
                                                accept={props.accept || documentAcceptType[i]}
                                                onFile={onFile}
                                                count={dt.documentPages}
                                                docId={dt.id}
                                                active={active}
                                                isLivePhotoCapture={props.isLivePhotoCapture && dt.documentTypeName === "Photograph & Signature"}
                                                handleLivePhotoCapture={props.handleLivePhotoCapture}
                                                //activate={docList.length === 1}
                                                docName={dt.documentName}
                                                center={classes.center}
                                                index={i}
                                                current={active === i}
                                                image={"images/uploadIcon.svg"}
                                                activeImage={"images/upload_icon_active.svg"}
                                                text={dt.documentName}
                                                setId={() => props.setId({
                                                    docExpDate: dt.isMandatoryDocExpiryDate,
                                                    docNumber: dt.isMandatoryDocNumber
                                                })}
                                                mappingKey={dt.mappingKey}
                                                boxStyle={i === active ? classes.active : classes.uploadWrapper}
                                            />
                                        </Grid>
                                        <Grid item md={2}>
                                        </Grid>
                                    </Grid>}
                            </Grid>
                        })}
                        </>
                }
            </Grid>
        </DialogContent>
    </Dialog>
}

export default /* withStyles(Styles) */(ProofDialog)